const initialState = {
   searchResults: [],
   suggestions: [],
};

export default function (state = initialState, action) {
   switch (action.type) {
       case 'MANUAL_VIDEO_FETCHED_FULFILLED': {
           return {
               ...state,
               videos: action.payload};
       }
       case 'YOUTUBE_AUTOCOMPLETE_FETCHED': {
         return {
             ...state,
             suggestions: action.payload};
      }
       case 'VIDEOS_FETCHED_PENDING': {
           // clears previous results
           return {
               ...state,
               searchResults: []
           };
       }
      case 'VIDEOS_FETCHED_FULFILLED': {
         return {
            ...state,
            searchResults: action.payload.data
         };
      }
      default:
         return state;
   }

}



// WEBPACK FOOTER //
// ./src/reducers/youtubeVideosReducer.js